// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__Tjef4","header":"PatientQuestionnaire_header__S8Xaz","info":"PatientQuestionnaire_info__2GvCa"};